export default __webpack_public_path__ + "assets/images/0e3f8287dcfd57c9f78d68a3060b602f.png";